"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subjectSmsApi = void 0;
const sendEcoaAccessSms = {
    method: "POST",
    url: "/subject/ecoa-access/send",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const sendEcoaAuthenticateSms = {
    method: "POST",
    url: "/subject/ecoa-authenticate/send",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const getStudySubjectSmsHistory = (studyId, subjectId) => ({
    method: "GET",
    url: `/studies/${studyId}/subjects/${subjectId}/sms`,
    reducer: resp => resp,
    errReducer: resp => resp,
});
const createSubjectSmsHistoryDownloadUrl = (studyId) => ({
    method: "POST",
    url: `/studies/${studyId}/subjects/sms/download`,
    reducer: resp => resp,
    errReducer: resp => resp,
});
exports.subjectSmsApi = {
    sendEcoaAccessSms,
    sendEcoaAuthenticateSms,
    getStudySubjectSmsHistory,
    createSubjectSmsHistoryDownloadUrl,
};
//# sourceMappingURL=subjectSms.js.map